export const wait = (delayMs: number): { cancel: () => void; promise: Promise<void> } => {
    let cancel = (): void => undefined;

    const promise = new Promise<void>(res => {
        const id = setTimeout(res, delayMs);

        cancel = () => {
            clearTimeout(id);
            res();
        };
    });

    return {
        cancel,
        promise,
    };
};
